import { render, staticRenderFns } from "./repairConfirm.vue?vue&type=template&id=107bb7f8&"
import script from "./repairConfirm.vue?vue&type=script&lang=js&"
export * from "./repairConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports